import { Component, OnInit } from '@angular/core';
import { BankTransfer } from '../model/banktransfer';
import { FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, FormBuilder } from '@angular/forms';
import * as IBAN from 'iban';

export function validateIBAN(control: AbstractControl) {
  const invalid = (!control.value || IBAN.isValid(control.value));
  return invalid ? null : {'iban': {value: control.value}};
}

@Component({
  selector: 'app-datainput',
  templateUrl: './datainput.component.html',
  styleUrls: ['./datainput.component.scss']
})
export class DataInputComponent implements OnInit {

  btForm: FormGroup;
  qrcodedata: String;

  constructor(private fb: FormBuilder) {
    this.btForm = this.fb.group({
      'name': ['', [
        Validators.required,
      ]],
      'iban': ['', [ Validators.required,
      validateIBAN ]],
      'bic': [''],
      'amount': ['', Validators.required],
      'reason': ['', Validators.required],
    });
   }

  ngOnInit() {
  }

  onSubmit(event) {
    const data =  this.btForm.value;
    let url = 'bank://singlepaymentsepa';
    url += '?name=' + encodeURIComponent(data.name.trim());
    url += '&reason=' + encodeURIComponent(data.reason.trim());
    url += '&iban=' + encodeURIComponent(IBAN.electronicFormat(data.iban));
    if (data.bic && (data.bic.trim().length > 0)) {
      url += '&bic=' + encodeURIComponent(data.bic.trim());
    }
    url += '&amount=' + encodeURIComponent(data.amount.trim());
    this.qrcodedata = url;
  }

  clearData() {
    this.qrcodedata = null;
    this.btForm.reset();
  }


  getErrorMessage() {
    return this.btForm.hasError('required') ? 'You must enter a value' :
        this.btForm.hasError('email') ? 'Not a valid email' :
            '';
  }

}



// WEBPACK FOOTER //
// ./src/app/datainput/datainput.component.ts